export default class ClubAccessSettings {
    autoLogoutTime;
    membersEditOwnData;
    membersCanViewInvoices;
    sendBirthdayGreetings;
    defaultPaymentInterval;
    memberSinceDateStrategy;
    onlineMembershipTerminationEnabled;
    physicalAccessStateResetHour;
    hasPhysicalAccessModule;
    invoiceNotificationTiming;
    invoiceNotificationDays;

    static fromData(data) {
        if (!data) {
            return;
        }

        let settings = new ClubAccessSettings();
        settings.autoLogoutTime = data.autoLogoutTime;
        settings.membersEditOwnData = data.membersEditOwnData;
        settings.membersCanViewInvoices = data.membersCanViewInvoices;
        settings.sendBirthdayGreetings = data.sendBirthdayGreetings;
        settings.defaultPaymentInterval = data.defaultPaymentInterval;
        settings.memberSinceDateStrategy = data.memberSinceDateStrategy;
        settings.onlineMembershipTerminationEnabled = data.onlineMembershipTerminationEnabled;
        settings.physicalAccessStateResetHour = data.physicalAccessStateResetHour;
        settings.hasPhysicalAccessModule = data.hasPhysicalAccessModule;
        settings.invoiceNotificationTiming = data.invoiceNotificationTiming;
        settings.invoiceNotificationDays = data.invoiceNotificationDays;

        return settings;
    }

    serialize() {
        return {
            autoLogoutTime: parseInt(this.autoLogoutTime),
            membersEditOwnData: this.membersEditOwnData,
            membersCanViewInvoices: this.membersCanViewInvoices,
            sendBirthdayGreetings: this.sendBirthdayGreetings,
            defaultPaymentInterval: this.defaultPaymentInterval,
            memberSinceDateStrategy: this.memberSinceDateStrategy,
            onlineMembershipTerminationEnabled: this.onlineMembershipTerminationEnabled,
            physicalAccessStateResetHour: this.physicalAccessStateResetHour !== null ? parseInt(this.physicalAccessStateResetHour) : null,
            invoiceNotificationTiming: this.invoiceNotificationTiming,
            invoiceNotificationDays: this.invoiceNotificationDays !== null ? parseInt(this.invoiceNotificationDays) : null,
        };
    }
}
